export const environment = {
  production: false,
  baseUrl: 'https://api-staging.kyrainnovations.com/v1/'
  
};
